module.exports = __webpack_public_path__ + "img/item-8(1920)new.1cb6af52.jpg";